<script>
	// The params prop contains values matched from the URL
	export let params = {} 

	import { createEventDispatcher, onMount } from 'svelte';
	import { replace } from 'svelte-spa-router';
	import { 
		gerarStringAleatoria, 
		StatusHttp, 
		TipoEvento,
		cabecalhoPadraoRequisicao,
		API, 
		TextoFeedback } from '../../utils';
	import { sCaptcha } from '../../stores';
	import TBox from '../templates/TBox.svelte';
	import Captcha from '../../componentes/Captcha.svelte';

	const dispatch = createEventDispatcher();
	
	// variáveis para trabalhar com os dados do formulário
	let captchaUsuario;
	let tituloAviso = "Erro";
	let feedbackUsuario = [];
	let idUsuarioAlvo;
	let perfilEscolhido;
	let perfisCadastrados;
	let perfis = [];
	let informacosAPICache = null;

	onMount(async () => {
		informacosAPICache = JSON.parse(localStorage.getItem('AVAL_API_INFO_CACHE'));
		perfis = Object.entries(informacosAPICache.perfis).sort();

		perfisCadastrados = window.atob(params.perfisCadastradosBase64);
		idUsuarioAlvo = Number.parseInt(params.idUsuario);
	});

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Alterando ...',
		});
			
		if (captchaUsuario != $sCaptcha) {
			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Captcha Inválido',
				conteudo: 'O código informado é inválido, tente novamente.'
			});
			
			// atualiza o store
			sCaptcha.update(novaString => gerarStringAleatoria());
		} else {

			// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
			const resposta = await fetch(API('usuarios/alterar-perfil'), {
				method: 'PATCH',
				headers: cabecalhoPadraoRequisicao(),
				body: JSON.stringify({
					idUsuarioAlvo: idUsuarioAlvo,
					perfil: perfilEscolhido,
					operacao: event.submitter.value
				})
			}).catch(erros => {
				feedbackUsuario.push(TextoFeedback.ERRO_REQUISICAO);
				
				dispatch('routeEvent', { 
					tipo: TipoEvento.ESTA_CARREGANDO,
					valor: false
				});
				
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			});

			// pega o json do retorno da resposta
			const json = await resposta.json();

			if (resposta.status == StatusHttp.OK) {		
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: 'Tudo certo!',
					conteudo: json?.mensagem
				});

				replace('/usuario/listagem');
			} else {
				feedbackUsuario.push(json?.mensagem ?? 'Erro desconhecido, se persistir, favor entrar em contato.');
			}

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});

			// exibe feedback pro usuário se existir algo pra exibir
			if (feedbackUsuario[0]) {
				dispatch('routeEvent', {
					tipo: TipoEvento.ABRIR_MODAL,
					titulo: tituloAviso,
					conteudo: feedbackUsuario[0]
				});
			}

			// limpa as mensagens
			feedbackUsuario = [];
		}
	}
</script>

<TBox 
	titulo="Alteração de Perfil" 
	subtitulo="Informe os dados abaixo para prosseguir" 
	largura="8" 
	deslocamento="2" 
	correcaoY="-13px"
	icone="usuario">
	
	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<span class="alert">Usuário (CPF): {params.cpf}</span>
		<br>
		<span class="alert">Perfis cadastrados: {perfisCadastrados}</span>

		<hr>
		<p>Selecione o novo perfil abaixo, confirme o captcha e clique na opção desejada.</p>
		<br>

		<div class="columns is-mobile">
			<div class="column"> 
				<small class="has-text-primary">Perfil de acesso:</small>
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={perfilEscolhido} name="perfil" required>
						<option value="">Escolha um perfil...</option>
						{#each perfis as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
		</div>
		
		<div class="columns is-mobile">
			<div class="column is-half">
				<Captcha />
			</div>
			<div class="column is-half">
				<input 
					name="captcha"
					bind:value={captchaUsuario}
					type="text"
					maxlength="8" 
					placeholder="Digite o código aqui" 
					class="input is-large is-primary" required>
			</div>
		</div>

		<div class="columns">
			<div class="column">
				<p class="control">
					<a href="#/painel/usuarios" class="button is-black is-medium is-outlined is-fullwidth">Voltar</a>
				</p>
			</div>
			<div class="column is-4">
				<p class="control">
					<button 
						type="submit" 
						value="OPERACAO_ADICIONAR_PERFIL"
						class="button is-success is-medium is-fullwidth">
						Adicionar
					</button>
				</p>
			</div>
			<div class="column is-4">
				<p class="control">
					<button 
						type="submit" 
						value="OPERACAO_REMOVER_PERFIL"
						class="button is-danger is-medium is-fullwidth">
						Remover
					</button>
				</p>
			</div>
		</div>
	</form>
</TBox>